import { ReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { connect } from 'react-redux';
import type { QuoteDetailsData } from 'state/quotes/details/details.model';
import { getFormQuoteDetails, getFormQuoteId, getFormRequestType, getIsUserInternal } from 'state/selectors';
import { getQuoteExternalIdByWorkspaceTab } from 'state/selectors/common/temp';
import { hasProductDumpDetails, hasQuoteDetails } from 'state/selectors/meta/quote/utils';
import type { AppState } from 'state/state.model';
import { getSidePanelQuoteDetailsFieldsMetadata } from 'state/uiPanelState/sidePanelUi/sidePanelUi.selectors';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  isInternalUser: boolean;
  hasDetails: boolean;

  hasProductDump: boolean;

  quoteId: string;
  externalQuoteId: string;
  quoteDetails?: QuoteDetailsData;

  quoteDetailsMetadata?: Readonly<Record<string, ReadonlyValueDefinition>>;
  fieldsShouldBeReferenced?: boolean;
}
export type InfoProps = OwnProps & StateProps;

export function getSidePanelQuoteDetails(quoteDetails: QuoteDetailsData | undefined): QuoteDetailsData | undefined {
  if (quoteDetails?.SupplementDetails === undefined) {
    return quoteDetails;
  }

  const { SupplementDetails: _supplementDetails, ...quoteDetailsWithoutSupplementDetails } = quoteDetails;
  return quoteDetailsWithoutSupplementDetails;
}

export const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const externalQuoteId = getQuoteExternalIdByWorkspaceTab(state, workspaceType, tabId)!;
  const quoteId = getFormQuoteId(state, workspaceType!, tabId)!;
  const quoteDetails = getSidePanelQuoteDetails(getFormQuoteDetails(state, workspaceType, tabId));
  const isInternalUser = getIsUserInternal(state);
  const requestType = getFormRequestType(state, workspaceType, tabId);
  const quoteDetailsMetadata = getSidePanelQuoteDetailsFieldsMetadata(state, tabId);
  return {
    hasDetails: hasQuoteDetails(state, workspaceType, tabId),
    hasProductDump: hasProductDumpDetails(state, workspaceType, tabId),
    isInternalUser,
    externalQuoteId,
    quoteId,
    quoteDetails,
    fieldsShouldBeReferenced: requestType !== 'RequestForStream',
    quoteDetailsMetadata,
  };
};

export const connectQuoteInfos = connect(mapStateToProps);
